import React from 'react'

import { calculateDuration, formatDurationFromMilliseconds, formatDurationBetweenDates } from './DateUtils';

const DurationCalculator = props => {
  // Presentational wrapper that ensures duration strings can be rendered within table cells.
  return <span>{props.text}</span>;
};

const dateDiff = date => {
  // Format the elapsed time between the provided date and the current moment.
  return <DurationCalculator text={calculateDuration(date)} />;
};

const checkProcessDuration = (duration, createdAt, updatedAt, state) => {
  if (state == 'NOT_STARTED') {
    return ""
  } else {
    return parseDuration(duration, createdAt, updatedAt)
  }
}

const parseDuration = (duration, createdAt, updatedAt) => {
  // Duration values are persisted as ISO-like strings relative to epoch; convert them into a localized absolute duration.
  let formatted = '';

  if (duration) {
    const milliseconds = Date.parse(duration);
    if (!Number.isNaN(milliseconds)) {
      formatted = formatDurationFromMilliseconds(milliseconds);
    }
  }

  if (!formatted && createdAt && updatedAt) {
    formatted = formatDurationBetweenDates(createdAt, updatedAt);
  }

  return <DurationCalculator text={formatted || '-'} />;
};

export {
    dateDiff,
    checkProcessDuration,
    parseDuration,
}

